module.exports = __webpack_public_path__ + "static/media/about__jangl_platform.79ff9889.png";